











































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IInbound from '@/store/models/IInbound';
import IOutbound from '@/store/models/IOutbound';
import moment from 'moment';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import IInboundDetail from '@/store/models/IInboundDetail';
import IListStatusInbound from '@/store/models/IListStatusInbound';
import IListStatusOutbound from '@/store/models/IListStatusOutbound';

@Component({
    components: {
        Snackbar
    }
})
export default class PlanningSelector extends Vue {
    @Prop({ type: Array, required: true })
    InboundsList !: IInbound[];

    @Prop({ type: Array, required: true })
    InboundDetailList !: IInboundDetail[];

    @Prop({ type: Array, required: true })
    OutboundsList !: IOutbound[];

    @Prop({ type: Array, required: true })
    OutboundDetailList !: IOutboundDetail[];

    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    @Prop({ type: Array, required: true })
    AvailableTimeSlots !: Number[];

    @Prop({ type: Array, required: true })
    ListStatusInbound !: IListStatusInbound[];

    @Prop({ type: Array, required: true })
    ListStatusOutbound !: IListStatusOutbound[];

    type: string = "week";
    types: string[] = ['month', 'week', 'day', '4day'];
    mode: string = 'stack';
    modes: string[] = ['stack', 'column'];
    value: string = '';
    events: any[] = [];
    weekday: any = [1, 2, 3, 4, 5, 6, 0];
    weekdays: any[] = [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] }
    ];
    colors: any = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
    names: any = ['Inbound', 'Outbound'];
    selectedEvent : any = {};
    selectedElement: any = null;
    selectedOpen: boolean = false;
    selectedStartTime: number = 0;
    selectedEndTime: number = 0;
    AvailableTimeSlotsEndTime: Number[] = [7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21];
    showMoreDialog: boolean = false;
    selectedDayEvents: any[] = [];
    selectedDay: any = '';

    created() {
        this.showEvents();
        setInterval(() => this.showEvents(), 90000);
    }

    async showEvents() {
        await this.getEvents();
    }

    @Watch('selectedStartTime')
    onChangeSelectedStartTime() {
        this.selectedEndTime = this.selectedStartTime + 1;
    }

    getEvents() {
        if (!this.InboundsList || !this.OutboundsList || !this.ListStatusInbound || !this.ListStatusOutbound) {
            this.events = [];
            return;
        }

        const events = [];
        const today = new Date();
        const todayStr = moment(today).format('YYYY-MM-DD');
        const todayDate = new Date(todayStr);

        // Inbounds
        for (let i = 0; i < this.InboundsList.length; i++) {
            const inbound = this.InboundsList[i];
            const allDay = false;

            if (inbound.startTime === null || inbound.startTime < 7) inbound.startTime = 6;
            if (inbound.endTime === null || inbound.endTime < 7) inbound.endTime = 6;

            const start = `${moment(inbound.dateIn).format('YYYY-MM-DD')}T${inbound.startTime.toString().padStart(2, '0')}:00:00`;
            const end = `${moment(inbound.dateIn).format('YYYY-MM-DD')}T${(inbound.endTime === 6 ? 6 : inbound.endTime - 1)
            .toString()
            .padStart(2, '0')}:59:59`;
            const statusName = (inbound.statusName || '').toLowerCase();
            const eventDate = new Date(moment(inbound.dateIn).format('YYYY-MM-DD'));

            let statusObj = this.ListStatusInbound.find(s => s.id === inbound.idStatus) || null;

            if (!statusObj && inbound.statusName) {
                statusObj = this.ListStatusInbound.find(
                    s => (s.name || '').toLowerCase() === inbound.statusName.toLowerCase()
                ) || null;
            }

            let color = (inbound as any).color || 'purple';

            if (statusObj && statusObj.isFinished) {
                color = 'green';
            } else if (statusName === 'completed') {
                color = 'cyan';
            } else if (statusObj && statusObj.color) {
                color = statusObj.color;
            }

            if (eventDate < todayDate && statusName !== 'completed' && !(statusObj && statusObj.isFinished)) {
                color = 'red';
            }

            events.push({
                name: `${inbound.code} - Inbound - ${inbound.statusName}`,
                start,
                end,
                color,
                timed: !allDay,
                status: `Status - ${inbound.statusName}`,
                companySourceName: `Company Source - ${inbound.companySourceName}`,
                customerName: `Customer - ${inbound.customerName}`,
                containernumber: `Container number - ${inbound.containerNumber}`,
                weight: `Weight - ${inbound.weight}`,
                sealNumber: `Seal number - ${inbound.sealNumber}`,
                code: 'I' + inbound.code,
                startTime: inbound.startTime,
                endTime: inbound.endTime,
                dateChanged: inbound.dateChanged
            });
        }

        // Outbounds
        for (let i = 0; i < this.OutboundsList.length; i++) {
            const outbound = this.OutboundsList[i];
            const allDay = false;

            if (outbound.startTime === null || outbound.startTime < 7) outbound.startTime = 6;
            if (outbound.endTime === null || outbound.endTime < 7) outbound.endTime = 6;

            const start = `${moment(outbound.dateOut).format('YYYY-MM-DD')}T${outbound.startTime.toString().padStart(2, '0')}:00:00`;
            const end = `${moment(outbound.dateOut).format('YYYY-MM-DD')}T${(outbound.endTime === 6 ? 6 : outbound.endTime - 1)
            .toString()
            .padStart(2, '0')}:59:59`;

            const statusName = (outbound.statusName || '').toLowerCase();
            const eventDate = new Date(moment(outbound.dateOut).format('YYYY-MM-DD'));

            let statusObj = this.ListStatusOutbound.find(s => s.id === outbound.idStatus) || null;

            if (!statusObj && outbound.statusName) {
                statusObj = this.ListStatusOutbound.find(
                    s => (s.name || '').toLowerCase() === outbound.statusName.toLowerCase()
                ) || null;
            }

            let color = (outbound as any).color || 'purple';

            if (statusObj && statusObj.isFinished) {
                color = 'green';
            } else if (statusName === 'completed') {
                color = 'cyan';
            } else if (statusObj && statusObj.color) {
                color = statusObj.color;
            }

            if (eventDate < todayDate && statusName !== 'completed' && !(statusObj && statusObj.isFinished)) {
                color = 'red';
            }

            events.push({
                name: `${outbound.code} - Outbound - ${outbound.statusName}`,
                start,
                end,
                color,
                timed: !allDay,
                status: `Status - ${outbound.statusName}`,
                companySourceName: `Company Source - ${outbound.companySourceName}`,
                customerName: `Customer - ${outbound.customerName}`,
                containernumber: `Container number - ${outbound.containerNumber}`,
                weight: `Weight - ${outbound.weight}`,
                sealNumber: `Seal number - ${outbound.sealNumber}`,
                code: 'O' + outbound.code,
                startTime: outbound.startTime,
                endTime: outbound.endTime,
                dateChanged: outbound.dateChanged
            });
        }

        this.events = events;
    }

    async openEventMenu(nativeEvent: any, event: any) {
        await this.showEvent({ nativeEvent, event });
    }

    async showEvent ({ nativeEvent, event }: any) {
        if (event.code.substring(0, 1) === 'I') {
            const index = this.InboundsList.findIndex(i => "I" + i.code === event.code);
            if (index !== -1) {
                await this.$emit("getInboundDetails", this.InboundsList[index]);
            }
        } else if (event.code.substring(0, 1) === 'O') {
            const index = this.OutboundsList.findIndex(i => "O" + i.code === event.code);
            if (index !== -1) {
                await this.$emit("getOutboundDetails", this.OutboundsList[index]);
            }
        }

        this.selectedStartTime = event.startTime;
        this.selectedEndTime = event.endTime;

        const open = () => {
            this.selectedEvent = event;
            this.selectedElement = nativeEvent.target;
            setTimeout(() => {
                this.selectedOpen = true;
            }, 10);
        };

        if (this.selectedOpen) {
            this.selectedOpen = false;
            setTimeout(open, 10);
        } else {
            open();
        }

        nativeEvent.stopPropagation();
    }

    showMoreEvents(date: any) {
        this.selectedDay = moment.utc({
            year: date.year,
            month: date.month - 1,
            day: date.day
        }).format('YYYY-MM-DD');
        
        this.selectedDayEvents = this.events.filter(event => {
            const eventDate = moment(event.start).format('YYYY-MM-DD');
            return eventDate === this.selectedDay;
        });

        this.showMoreDialog = true;
    }

    goToEvent(code: string) {
        if (this.selectedEvent) {
            if (code.substring(0, 1) === 'I') {
                this.$router.push({ name: 'Inbounds', params: { data: code.substring(1) } }).catch(() => {});
            } else if (code.substring(0, 1) === 'O') {
                this.$router.push({ name: 'Outbounds', params: { data: code.substring(1) } }).catch(() => {});
            }
        }
    }

    saveInboundSlotTime() {
        if (this.selectedStartTime > 0 && this.selectedEndTime > 0) {
            let canUpdate = true;
            let slot = 0;

            if ((this.selectedEndTime - this.selectedStartTime) > 1) {
                for (let i = this.selectedStartTime + 1; i < this.selectedEndTime; i++) {
                    if (!this.AvailableTimeSlots.includes(i)) {
                        canUpdate = false;
                        slot = i;
                    }
                }
            } else if (this.selectedEndTime < this.selectedStartTime) {
                canUpdate = false;
            }

            if (canUpdate) {
                if (this.selectedEvent.code.substring(0, 1) === 'I') {
                    this.selectedEvent.startTime = this.selectedStartTime;
                    this.selectedEvent.endTime = this.selectedEndTime;
                    const index = this.InboundsList.findIndex(i => "I" + i.code === this.selectedEvent.code);
                    if (index > -1) {
                        this.InboundsList[index].startTime = this.selectedStartTime;
                        this.InboundsList[index].endTime = this.selectedEndTime;
                        this.$emit("saveInboundTimeSlot", this.InboundsList[index]);
                        this.getEvents();
                    }
                } else if (this.selectedEvent.code.substring(0, 1) === 'O') {
                    const index = this.OutboundsList.findIndex(i => "O" + i.code === this.selectedEvent.code);
                    if (index > -1) {
                        this.OutboundsList[index].startTime = this.selectedStartTime;
                        this.OutboundsList[index].endTime = this.selectedEndTime;
                        this.$emit("saveOutboundTimeSlot", this.OutboundsList[index]);
                        this.getEvents();
                    }
                }
                this.selectedOpen = false;
            } else {
                if (slot === 12) {
                    this.$emit('showWarningMaxSlot', 'The 12-13 timeslot is reserved for the break. Select another timeslot.');
                } else if (slot > 8) {
                    this.$emit('showWarningMaxSlot', 'This timeslot ' + slot + ' hours already contains 3 in/outbounds. Please select another time.');
                } else if (this.selectedStartTime > this.selectedEndTime) {
                    this.$emit('showWarningMaxSlot', 'The end time cannot be less than the start time. Please select another time slot for the end time.');
                }
            }
        }
    }

    getEventColor (event: any) {
        return event.color;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
